import React from 'react';
import '../../dashboard.scss';
import {Sector} from "recharts";
import {radiusIncrement} from "../multiLevelPieChart";
import {truncatedText} from "../../dashboardUtils";

type CustomActiveShapeProps = {
    customInnerRadius?: number;
    customOuterRadius?: number;
    maxOuterRadius?: number;
    elementName: string;
    isLastIndex: boolean;
    index: number;
    datasetAmount: number;
    showInnerTekst: boolean;
    showCursorPointer?: boolean;
    onClickCallback: () => void;
};

export const CustomActiveShape = ({
                                      customOuterRadius,
                                      customInnerRadius,
                                      maxOuterRadius,
                                      elementName,
                                      isLastIndex,
                                      index,
                                      datasetAmount,
                                      onClickCallback,
                                      showInnerTekst = false,
                                      showCursorPointer = false,
                                      ...props
                                  }: CustomActiveShapeProps & any) => {
    const {cx, cy, outerRadius, innerRadius, startAngle, endAngle, fill, payload} = props;

    return (
        <g>
            {showInnerTekst &&
                <text x={cx} y={cy + 30} dy={8} textAnchor="middle" fill={fill}>
                    {truncatedText(payload.name, 15)}
                </text>
            }
            <Sector
                cursor={showCursorPointer ? "pointer" : "default"}
                onClick={onClickCallback}
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={isLastIndex
                    ? customOuterRadius + 6
                    : customOuterRadius + ((index) * radiusIncrement) + 6
                }
                outerRadius={isLastIndex
                    ? customOuterRadius + 10
                    : customOuterRadius + ((index) * radiusIncrement) + 10
                }
                fill={fill}
            />
        </g>
    );
};
